
<template>
  <div
    @mouseover="changeMask()"
    class="m-map"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <template v-if="isLoadAllData">
      <!-- 热门城市 -->
      <hotCity :isHome="isHome" />
      <!-- 左侧数据 -->
      <leftData
        :leftIndex="leftIndex"
        :btnIndex="roadType"
        @changeLeftIndex="changeLeftIndex"
        @initData="initData"
        :hotZoneAreas="hotZoneAreas"
        :leftData="leftData"
      />
      <!-- 全国道路右侧详情 -->
      <rightData
        v-if="showRightData"
        :clickId="clickId"
        :loadingRight="loadingRight"
        :itemData="objData"
      />
      <!-- 颜色 -->
      <colorSign />
      <!-- 地图 -->
      <mapDrag
        :allData="allData"
        :leftIndex="leftIndex"
        :listDatas="leftDatePath"
        :lnglats="lnglats"
        :hCityDetails="hCityDetails"
        :hotZoneAreas="hotZoneAreas"
        :isDblClickM="isDblClickM"
        ref="mapDrag"
        :isShowHotCity="isShowHotCity"
        @changeLeftIndex="changeLeftIndex"
        @getHCityDetails="getHCityDetails"
        @showNewPos="showNewPos"
        mapType='2'
      ></mapDrag>
      <!-- 新增站点弹框 -->
      <newPos
        v-if="isShowNewPos"
        :formLabelAlign="formLabelAlign"
        :nLeft="nLeft"
        :nTop="nTop"
        :isAdd="isAdd"
        @giveUp="giveUp"
        @confirmAddSite="confirmAddSite"
      />
    </template>
  </div>
</template>
<script>
import axios from '@/api/road.js'
import mapDrag from '../mapComponents/mapDragold.vue'
import colorSign from '../mapComponents/colorSign.vue'
import newPos from '../mapComponents/newPos.vue'
import hotCity from '../mapComponents/hotCity.vue'
import leftData from './leftData.vue'
import rightData from './rightData.vue'
import commonFun from '../assets/js/common.js'
import { constants } from 'crypto'
import { truncate } from 'fs'
export default {
  components: {
    mapDrag,
    hotCity,
    colorSign,
    leftData,
    rightData,
    newPos
  },
  data() {
    return {
      loading: false,
      loadingRight: false,
      dragStatus: false,
      isHome: true, //是否是首页
      AMapUI: null,
      AMap: null,
      leftIndex: null,
      showRightData: false,
      leftDatePath: [], //画线数组
      isShowNewPos: false, //是否显示添加站点
      isLoadAllData: false,
      allData: {},
      // 右侧详情
      objData: {},
      // 站点参数
      isAdd: true,
      nLeft: 0,
      nTop: 0,
      formLabelAlign: {},
      clickId: 0,
      roadType: '高速',
      lnglats: [],
      isDblClickM: false, //是否取消操作站点
      hCityDetails: [], //鼠标放上去展示热区详情
      hotZoneAreas: [],
      cityCode: '',
      cityDataObj: {}, //热门城市
      isShowHotCity: false
    }
  },
  props: {
    searchKeyVal: String,
    lat: Number,
    lng: Number
  },
  watch: {},
  created() {
    if (this.$route.query.id) {
      this.initData(
        this.$route.query.roadType,
        true,
        true,
        this.$route.query.id
      )
    } else {
      this.initData(this.roadType, true)
    }
  },
  methods: {
    changeMask() {
      // console.log(78)
      // var diff = 2000, //未操作触发间隔
      //   firstTime = new Date().getTime(),
      //   lastTime = new Date().getTime(),
      //   indulge = false
      // //启动
      // var switchTime
      // //停止
      // document.onmouseover = function() {
      //   indulge = true
      //   firstTime = new Date().getTime()
      //   console.log(firstTime)
      //   clearInterval(switchTime)
      // }
      // //再启动
      // setInterval(function() {
      //   lastTime = new Date().getTime()
      //   if (lastTime - firstTime > diff && indulge) {
      //     indulge = false
      //     var t = document.querySelector('.l-cont').scrollTop
      //     switchTime = setInterval(function() {
      //       t = t + 0.1
      //       document.querySelector('.l-cont').scrollTop = t
      //     }, 1)
      //   }
      // }, 1000)
    },
    // 初始化地图
    initData(roadType, isSign, isChildHref, id) {
      let _this = this
      _this.loading = true
      if (isSign) {
        this.leftData = []
        this.clickId = 0
        this.leftDatePath = []
      }
      this.roadType = roadType
      axios.getTop150Road(roadType, this.cityCode, this.clickId).then(e => {
        if (_this.clickId == 0) {
          _this.getSiteList()
          _this.allData = e.data
          var leftData = commonFun.returnColor(_this.allData.leftData, true)
          _this.hotZoneAreas = _this.allData.hotZoneAreas
          _this.leftData = [...leftData]
          //
          // _this.changeLeftIndex(leftData[0].id)
          // 是否是全部道路加载进来
          if (isChildHref) {
            _this.changeLeftIndex(parseInt(id))
          } else {
            // 是否是第一次加载
            _this.changeLeftIndex(leftData[0].id)
          }
        } else {
          var leftDatePath=[]
          if(e.data.leftData){
             leftDatePath = commonFun.returnColor(e.data.leftData, true)
          }
          _this.leftDatePath = [...leftDatePath]
        }
        _this.isLoadAllData = true
        _this.loading = false
        // setTimeout(function() {
        //   _this.showleftData=true
        // }, 2000)
      })
    },
    // 获取站点
    getSiteList() {
      var _this = this
      axios.getListSide({ cityName: null }).then(e => {
        if (e.data) {
          _this.lnglats = e.data
        }
      })
    },
    // 路线和左侧数据关联得ID
    changeLeftIndex(id) {
      var _this = this
      this.clickId = id
      var arr = this.leftData
      for (var v of arr) {
        if (v.id == id) {
          v.isShow = true
        } else {
          v.isShow = false
        }
      }
      this.initData(this.roadType, false)
      _this.leftData = [...arr]
      if (_this.leftIndex != id) {
        _this.loadingRight = true
        // 全国道路详情
        axios.getRoadDetails(id, '').then(e => {
          _this.objData = e.data
          _this.showRightData = true
          _this.loadingRight = false
        })
      }
    },
    confirmAddSite() {
      this.getSiteList()
      this.isDblClickM = false
      this.isShowNewPos = false
    },
    // 取消添加站点
    giveUp() {
      if (this.isAdd) {
        var lnglats = this.lnglats
        lnglats.pop()
        this.lnglats = [...lnglats]
      }
      this.isDblClickM = false
      this.isShowNewPos = false
    },
    showNewPos(e, isAdd, obj) {
      this.nLeft = e.x
      this.nTop = e.y
      this.isAdd = isAdd
      this.formLabelAlign = obj
      this.isShowNewPos = true
    },
    // 鼠标放上去获取城市运营详情
    getHCityDetails(code) {
      var _this = this
      _this.hCityDetails = []
      axios.getHCityDetails(code).then(e => {
        var data = []
        data.push(e.data)
        _this.hCityDetails = [...data]
      })
    }
    // // 删除站点
    // deleteSide(id) {
    //   console.log(id)
    //   axios.deleteSide({ id: id }).then(e => {
    //     console.log(e)
    //   })
    // }
  }
}
</script>
<style>
.road-operation-main {
  padding: 0 !important;
  overflow: hidden;
}
.m-map,
#js-container {
  width: 100%;
  height: 100%;
  position: relative;
}
button:hover {
  cursor: pointer;
}
.el-loading-mask {
  z-index: 9999;
}
</style>